export type LockedObject = {
    lockedBy: {
        _id: string
        name: string
    }
    lockedAt: string | Date
}

export const isCellLocked = (locked?: LockedObject | null): boolean => {
    return !!locked?.lockedBy?._id
}
